export default __webpack_public_path__ + "static/media/tech-support-blue.6121651e.svg";